import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxComponent, DxCheckBoxModule, DxTemplateModule, DxTooltipModule } from 'devextreme-angular';
import { FusService } from '../../../services/formulacion/fus.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { AccionEspecificaService } from '../../../services/formulacion/accion-especifica.service';
import { OperacionService } from '../../../services/formulacion/operacion.service';
import { TareaService } from '../../../services/formulacion/tarea.service';
import { GeneralService } from '../../../services/formulacion/general.service';
import { ReversionService } from '../../../services/formulacion/reversion.service';
import { FusPartida } from '../../../models/fusPartida';
import { Jsonp } from '@angular/http';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-list-fus',
  templateUrl: './list-fus.component.html',
  styleUrls: [],
  providers: [AccionEspecificaService, OperacionService, TareaService, FusService, GeneralService, ReversionService]
})
export class ListFusComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxSelectBoxComponent) selectBox: DxSelectBoxComponent
  montoPAC: number = 0;
  listaPac: any[];
  esEditable: boolean = false;
  verContratacionMayor: number = 0;
  montoFus: number = 0;
  fuses: any[];
  techoId: string;
  fusEdit: any;
  modelFus: any = { id: 0, objeto: '', justificacion: '', sw_pasajes: false, techo_id: 0, objeto_id: 0, solicitud_pac_id: 0, fuentes: [] };
  AE: any = [];
  operaciones: any = [];
  tareas: any = [];
  fuentes: any = [];
  fuenteMod = 0;
  organismoMod = 0;
  fusId: number = 0;
  fusIdD: number = 0;
  montoTotal: number = 0;
  poaTecho: any;
  clicked: boolean = false;
  dsbo: boolean = true;
  dsbt: boolean = true;
  ff: boolean = false;
  sf: boolean = true;
  modelObjetoC: any = { id: 0, destinatario: '', pagoDe: '', tipo_id: 0 };
  popupVisibleAdd: boolean = false;
  popupVisibleEdit: boolean = false;
  popupVisibleMod: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleEstado: boolean = false;
  popupVisibleSeg: boolean = false;
  popupVisibleR: boolean = false;
  popupVisibleICG: boolean = false;
  popupVisibleCG: boolean = false;
  baseUrl = environment.apiEndpoint;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  fusSeg: string = '';
  dataSeg: any = [];
  fusMod: any = [];
  acciones: any = [{ id: 1, accion: 'Aumentar' }, { id: 2, accion: 'Disminuir' }];
  detPartidas: FusPartida[] = [];
  fusReversion: any;
  jusReversion = false;
  incFusCG: any = [];
  claseGasto: any = [];
  hasError: any;
  dateActual: Date = new Date();
  rol: number = 0;
  uId: number = 0;
  gestionSesionU: number = 0;
  tipoOC: any = [];
  claseOC: any = [];
  objetoContratacion: string = '';
  toolTiopObjetoContratacion: string = '';
  id_oc: number = 0;
  uno_c: string = '';
  dos_c: string = '';
  tres_c: string = '';
  cuatro_c: string = '';
  lblcuatro_c: string = 'Objeto';
  tieneDestinatario: boolean = true;
  tipoContratacion: any[] = [{ id: 2, descripcion: 'No corresponde PAC (hasta 20.000,00)' }, { id: 1, descripcion: 'Corresponde PAC (mayor a 20.000,00)' }];
  constructor(private route: ActivatedRoute, private _fs: FusService, private _as: AccionEspecificaService, private _os: OperacionService, private _ts: TareaService, private _gs: GeneralService, private _rs: ReversionService) {
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.techoId = params.get('id'))).subscribe();
    this.getListFus();
    this.getPoaTecho();
    this.getOperacionesByByTechoId();
    this.getListClaseGasto();
    this.getListaPac();
    this.resetErrors();
    this.gestionSesionU = JSON.parse(localStorage.getItem('g'));
    let u = JSON.parse(localStorage.getItem('u'));
    this.uId = u.id;
    this.rol = u.rol;
  }

  ngOnInit() {
  }

  getListFus() {
    this._fs.getListFusByTechoId(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.fuses = result.data; }
        else { this.fuses = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getObjetoContratacion() {
    this._fs.getObjetoContratacion().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.tipoOC = result.data; }
        else { this.tipoOC = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getListAE() {
    this._as.getListAccionEspecificaByTechoId(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.AE = result.data; }
        else { this.AE = []; }
      },
      (error) => { console.log('Error', error); });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.getObjetoContratacion();
    let date = new Date();
    if (this.gestionSesionU == date.getFullYear()) {
      this.fuentes = []; this.tareas = []; this.operaciones = [];
      this.getOperacionesByByTechoId();
      this.modelFus.objeto = '';
      this.modelFus.justificacion = '';
      this.popupVisibleAdd = true;
      this.montoTotal = 0;
    }
    else if (this.rol == 23) {
      this.fuentes = []; this.tareas = []; this.operaciones = [];
      this.getOperacionesByByTechoId();
      this.modelFus.objeto = '';
      this.modelFus.justificacion = '';
      this.popupVisibleAdd = true;
      this.montoTotal = 0;

    } else {
      toastr.warning('Debe cambiar a la Gestión ' + this.dateActual.getFullYear() + ' para poder solicitar el FUS');
    }
  }

  getPoaTecho() {
    this._gs.getPoaTechoById(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.poaTecho = result.data; }
        else { this.poaTecho = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getOperacionesByByTechoId() {
    this._os.getListoperacionesByTechoId(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.operaciones = result.data; }
        else { this.operaciones = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getOperacionesByAEId(e: any) {
    if (e.value != undefined && e.value != null) {
      this._os.getListOperacionesByAeId(e.value).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.operaciones = result.data; }
          else { this.operaciones = []; }
        },
        (error) => { console.log('Error', error); });
      this.dsbo = false;
    }
    this.fuentes = []; this.tareas = [];
  }

  getTareasByOperacionId(e: any) {
    if (e.value != undefined && e.value != null) {
      this._ts.getListTareasByOperacionId(e.value).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.tareas = result.data; console }
          else { this.tareas = []; }
        },
        (error) => { console.log('Error', error); });
      this.dsbt = false;
    }
    this.fuentes = [];
  }

  getFuentesByTareaIdFUS(e: any) {
    if (e.value != undefined && e.value != null) {
      this._fs.getPatidasByTareaIdFUS(e.value).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.fuentes = result.data; }
          else { this.fuentes = []; }
          this.sf = false;
        },
        (error) => { console.log('Error', error); });
      this.dsbt = false;
      this.fuenteMod = 0;
      this.organismoMod = 0;
      this.ff = false;
    }
  }

  saveFus() {
    let date = new Date();
    if (this.gestionSesionU == date.getFullYear()) {
      this.resetErrors();
      this.modelFus.fuentes = this.fuentes.filter(o => (o.fuente_id == this.fuenteMod && o.organismo_id == this.organismoMod)).map(o => o.partidas)[0];
      this.modelFus.techo_id = this.techoId;
      if (this.validSave()) {
        this.clicked = true;
        this._fs.postFus(this.modelFus).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.refreshDataGrid();
              toastr.success('Formulario Único de Solicitud generado exitosamente.');
              this.clicked = false;
              this.popupVisibleAdd = false;
            }
            else if (result.status == 201) {
              this.incFusCG = result.data;
              this.popupVisibleICG = true;
              this.clicked = false;
            }
            else if (result.status == 202) {
              toastr.warning(result.data);
              this.clicked = false;
            }
          },
          (error) => { console.log('Error', error); });
      }
    } else {
      toastr.warning('Debe cambiar a la Gestión ' + this.dateActual.getFullYear() + ' para poder solicitar el FUS');
    }
  }

  updateFus() {
    this.clicked = true;
    this.resetErrors();
    if (this.validSaveE()) {
      this._fs.updateFus(this.fusEdit).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.refreshDataGrid();
            toastr.success('Formulario Único de Solicitud actualizado exitosamente.');
            this.clicked = false;
            this.popupVisibleEdit = false;
          }
          else if (result.status == 201) {
            this.incFusCG = result.data;
            this.popupVisibleICG = true;
            this.clicked = false;
          }
          else if (result.status == 202) {
            this.refreshDataGrid();
            this.popupVisibleEdit = false;
            toastr.warning(result.data);
            this.clicked = false;
          }
        },
        (error) => { console.log('Error', error); });
    }
    else {
      this.clicked = false;
    }
  }

  resetErrors() {
    this.hasError = { objeto: false, justificacion: false, objeto_contratacion: false, objeto_tipo: false, objeto_id: false, solicitud_pac_id: false };
  }

  validSave() {
    let res = true;
    if (!this.modelFus.objeto || this.modelFus.objeto.trim() == '') {
      this.hasError.objeto = true; res = false;
    }
    if (!this.modelFus.justificacion || this.modelFus.justificacion.trim() == '') {
      this.hasError.justificacion = true; res = false;
    }
    if (this.modelFus.fuentes == undefined) {
      toastr.warning('Debe agregar un monto diferente de cero en alguna partida existente.'); res = false;
    }

    if (this.verContratacionMayor == 1) {

      if (this.modelFus.solicitud_pac_id == 0) {
        this.hasError.solicitud_pac_id = true; res = false;
      } else {
        if (this.montoTotal > this.montoPAC) {
          res = false;
          toastr.warning('El monto Total, no debe ser mayor al monto inscrito en el PAC: ' + this.montoPAC);

        }
        if ((this.montoTotal < 20000) || (this.montoTotal > this.montoPAC)) {
          res = false;
          toastr.warning('El monto Total, no corresponde a un monto de Contratación Mayor');

        }
      }
    }

    return res;
  }

  validSaveE() {
    let res = true;
    if (!this.fusEdit.objeto || this.fusEdit.objeto.trim() == '') {
      this.hasError.objeto = true; res = false;
    }
    if (!this.fusEdit.justificacion || this.fusEdit.justificacion.trim() == '') {
      this.hasError.justificacion = true; res = false;
    }
   
    if (this.montoTotal <= 0) {
      toastr.warning('Debe agregar un monto diferente de cero en alguna partida existente.'); res = false;
    }
    if ((this.montoTotal <= 20000) && (this.esEditable == true)) {
      toastr.warning('El monto total no corresponde a un FUS con solicitud PAC.'); res = false;
    }
    return res;
  }

  calculaSaldo(fuenteId: number, organismoId: number, id: number) {
    let s = 0;
    for (var i = 0; i < this.fuentes.length; i++) {
      if (this.fuentes[i].fuente_id == fuenteId) {
        for (var j = 0; j < this.fuentes[i].partidas.length; j++) {
          if (this.fuentes[i].partidas[j].tarea_detalle_financiador_id == id) {
            this.fuentes[i].partidas[j].saldo2 = (parseFloat(this.fuentes[i].partidas[j].saldo) - (parseFloat(this.fuentes[i].partidas[j].monto_fus) + parseFloat(this.fuentes[i].partidas[j].enproceso))).toFixed(2);
            if (parseFloat(this.fuentes[i].partidas[j].monto_fus) > 0) {
              this.fuenteMod = fuenteId;
              this.organismoMod = organismoId;
              this.ff = true;
            }
          }
          s += parseFloat(this.fuentes[i].partidas[j].monto_fus);
        }
      }
    }
    this.montoTotal = parseFloat(s.toFixed(2));
  }

  calculaSaldoEdit(id: number) {
    let s = 0;
    for (var i = 0; i < this.fusEdit.detalle.length; i++) {
      if (this.fusEdit.detalle[i].tarea_detalle_financiador_id == id) {
        this.fusEdit.detalle[i].saldo2 = (parseFloat(this.fusEdit.detalle[i].saldo) - (parseFloat(this.fusEdit.detalle[i].monto_fus) + parseFloat(this.fusEdit.detalle[i].monto_incrementado) + parseFloat(this.fusEdit.detalle[i].enproceso))).toFixed(2);
      }
      s += parseFloat(this.fusEdit.detalle[i].monto_fus);
    }
    this.montoTotal = parseFloat(s.toFixed(2));
  }

  refreshDataGrid() {
    this.getListFus();
    this.dataGrid.instance.refresh();
  }

  getFusById(id: string) {

    if (this.gestionSesionU == this.dateActual.getFullYear()) {
      //this.getObjetoContratacion();
      let s = 0, e = 0;
      this._fs.getFusById(id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            
            this.fusEdit = result.data;
            for (var i = 0; i < this.fusEdit.detalle.length; i++) {
              s += parseFloat(this.fusEdit.detalle[i].monto_fus);
              //if (this.fusEdit.detalle[i].partida_presupuestaria_id == 51)
               // e = 1;
            }
            this.montoTotal = s;
            
            if ((this.fusEdit.solicitud_pac_id != 0) && (this.fusEdit.solicitud_pac_id != null)) {
              if (e == 1)
                this.esEditable = false;
              else if (this.uId == 12)
                this.esEditable = false;
              else
                this.esEditable = true;
              this.getListaPac();
              this.verContratacionMayor = 1;
              this.modelFus.objeto_id = 1;
              this.modelFus.solicitud_pac_id = result.data.solicitud_pac_id;
              this.fusEdit.solicitud_pac_id = result.data.solicitud_pac_id;

            }
            else {
              this.esEditable = false;
              this.modelFus.objeto_id = 2;
              this.modelFus.objeto_contratacion_tipo_id = 0;
              this.verContratacionMayor = 2;
              this.modelFus.solicitud_pac_id = 0;
              this.fusEdit.solicitud_pac_id = 0;

            }
            this.popupVisibleEdit = true;
          }
        },
        (error) => { console.log('Error', error); });
    }
    else {
      toastr.warning('Debe cambiar a la Gestión ' + this.dateActual.getFullYear() + ' para poder solicitar el FUS');
    }

  }

  showModalEnviarRevision(id: number) {
    this.fusId = id;
    this.popupVisibleEstado = true;
  }

  enviarRevision() {
    this.clicked = true;
    this._fs.updateFusEstadoRevision({ id: this.fusId }).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.refreshDataGrid();
          toastr.success('Operación ejecutada exitosamente.');
          this.clicked = false;
        }
        this.popupVisibleEstado = false;
      },
      (error) => { console.log('Error', error); });
  }

  showModalSeg(id: string, fus: string) {
    this.fusSeg = fus;
    this._fs.getSeguimientoByFusId(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.dataSeg = result.data; }
      },
      (error) => { console.log('Error', error); });
    this.popupVisibleSeg = true;
  }



  editFusModAprobado(id: string) {
    this.detPartidas = [];
    this._fs.getFusById(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fusEdit = result.data;
          result.data.detalle.forEach(item => {
            this.detPartidas.push({ id: item.poa_fus_detalle_id, partida: item.codigo_partida, descripcion: item.descripcion_partida, unidadMedida: item.unidad_medida, montoInicialp: item.monto_fusp, montoInicial: parseFloat(item.monto_fus), monto: 0, montoMax: parseFloat(item.monto), montoTecho: parseFloat(item.monto), accion: 1, justificacion: '' });
          });
        }
        this._fs.getFusModificacionesByFusId(id).subscribe(
          (response) => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) { this.fusMod = result.data; this.popupVisibleMod = true; }
          },
          (error) => { console.log('Error', error); });
      },
      (error) => { console.log('Error', error); });
  }

  saveFusMod(id: number) {
    let dp: any = this.detPartidas.filter(o => o.id == id).map(o => o);
    if (UtilHelper.validator(dp[0].justificacion, 'text')) {
      this._fs.postFusModificacion(dp[0]).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            toastr.success('FUS modificado correctamente.');
          }
          this.popupVisibleMod = false;
        },
        (error) => { console.log('Error', error); });
    }
    else {
      toastr.warning('Ingrese una justificación.');
    }
  }

  deleteModificacionPartida(id: number) {
    this._fs.deleteModificacionPartida(id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleMod = false;
          toastr.success('Operación realizada exitosamente.');
        } else {
          toastr.warning('Ocurrió un inconveniente al realizar la operación.');
        }
      },
      error => { console.log('Error', error); });
  }

  deleteFus() {
    this._fs.deleteFus(this.fusIdD).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleDel = false;
          this.refreshDataGrid();
          toastr.success('Operación realizada exitosamente.');
        } else if (result.status == 201) {
          this.popupVisibleDel = false;
          this.refreshDataGrid();
          toastr.success('Operación realizada exitosamente.');
        } else {
          toastr.warning('Ocurrió un inconveniente al realizar la operación.');
        }
      },
      error => { console.log('Error', error); });
  }

  showModalDelete(id: number) {
    this.fusIdD = id;
    this.popupVisibleDel = true;
  }

  getFusReversionesById(id: string) {
    this.resetErrors();
    this._rs.getFusReversionesById(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fusReversion = result.data;
          this.popupVisibleR = true;
        }
      },
      (error) => { console.log('Error', error); });
  }

  saveReversion() {
    this.jusReversion = false;
    if (this.validRev()) {
      this._rs.postFusReversion(this.fusReversion).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getListFus();
            this.dataGrid.instance.refresh();
            toastr.success('Datos guardados correctamente.');
            this.clicked = false;
          }
          this.popupVisibleR = false;
        });
    }
  }

  validRev() {
    let res = true, f1 = false, f2 = false;
    if (!UtilHelper.validator(this.fusReversion.justifica_reversion, 'text')) {
      f1 = true;;
    }
    this.fusReversion.detalle.forEach(item => {
      if ((item.revertido < 0))
        f2 = true;
    });

    if (f2) {
      res = false;
      toastr.warning('Los montos no pueden ser ceros');
    }
    if (f1) {
      res = false;
      toastr.warning('Complete la justificación');
    }
    return res;
  }

  getListClaseGasto() {
    this._gs.getListClaseGasto().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.claseGasto = result.data; }
        else { this.claseGasto = []; }
      });
  }

  getTipoOC(e: any) {
    this.modelFus.objeto = '';
    if (e.value != undefined && e.value != null) {
      this.id_oc = e.value;
      this._fs.getObjetoContratacionTipo(e.value).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            //this.toolTiopObjetoContratacion = 'Reembolso a JUAN PEREZ por el pago de GASOLINA por el viaje realizado a la ciudad de Cochabamba del 21 al 22 de octubre del 2023';

            this.claseOC = result.data;
            if ((this.id_oc == 1) || (this.id_oc == 2) || (this.id_oc == 3))
              this.tieneDestinatario = true;
            else
              this.tieneDestinatario = false;

            switch (this.id_oc) {
              case 1:
                this.uno_c = 'Reembolso a ';
                break;
              case 2:
                this.uno_c = 'Solicitud de anticipo de fondo rotativo a favor de ';
                break;
              case 3:
                this.uno_c = 'Fondos en avance a ';
                break;
              case 4:
                this.uno_c = 'Pago por el servicio de ';
                break;
              case 5:
                this.uno_c = 'Servicio de ';
                break;
              default:
                this.uno_c = '';
            }
            this.modelFus.objeto = this.uno_c;
          }
          else { this.claseOC = []; }
        },
        (error) => { console.log('Error', error); });
    }
  }

  getClaseOC(e: any) {
    this.modelFus.objeto = '';
    this.objetoContratacion = e.component.option("text");
    if (this.id_oc == 1)
      if (this.objetoContratacion == 'Otros')
        this.tres_c = '';
      else
        this.tres_c = 'por el pago de ' + this.objetoContratacion;
    if (this.id_oc == 2)
      if (this.objetoContratacion == 'Otros')
        this.tres_c = '';
      else
        this.tres_c = 'para el pago de ' + this.objetoContratacion;
    if (this.id_oc == 3)
      if (this.objetoContratacion == 'Otros')
        this.tres_c = '';
      else
        this.tres_c = 'para el pago de ' + this.objetoContratacion;
    if (this.id_oc == 4)
      if (this.objetoContratacion == 'Otros')
        this.tres_c = '';
      else
        this.tres_c = this.objetoContratacion;
    if (this.id_oc == 5) {
      this.uno_c = '';
      this.dos_c = '';
      switch (this.objetoContratacion) {
        case 'Consultor de Línea':
          this.tres_c = 'Servicio de contratación Consultor de Línea ';
          break;
        case 'Consultor por Producto':
          this.tres_c = 'Servicio de Consultoría por Producto ';
          break;
        case 'Primera Adenda Consultoría':
          this.tres_c = 'Primer contrato modificatorio de ';
          break;
        case 'Segunda Adenda Consultoría':
          this.tres_c = 'Segundo contrato modificatorio de ';
          break;
        case 'Otros':
          this.tres_c = '';
          break;
        case 'Servicios':
          this.tres_c = 'Servicio de ';
          break;
        case 'Bienes':
          this.uno_c = '';
          this.tres_c = 'Adquisición de ';
          break;
        default:
          this.tres_c = '';
      }
    }
    this.modelFus.objeto = this.uno_c + this.dos_c + ' ' + this.tres_c;
  }

  updateModelObjeto() {
    this.modelFus.objeto = '';
    this.cuatro_c = '';
    this.cuatro_c = this.modelObjetoC.pagoDe;
    this.modelFus.objeto = this.uno_c + this.dos_c + ' ' + this.tres_c + ' ' + this.cuatro_c;
  }

  updateNombreOC() {
    this.modelFus.objeto = '';
    this.dos_c = '';
    this.dos_c = this.modelObjetoC.destinatario;
    this.modelFus.objeto = this.uno_c + this.dos_c;
  }

  getContratacion(e: any) {
    this.modelFus.objeto = '';
    this.verContratacionMayor = e.value;
    if (this.verContratacionMayor == 1) {
      this.verContratacionMayor = 1;
      this.esEditable = true;
    }
    else {
      this.verContratacionMayor = 2;
      this.modelFus.solicitud_pac_id = 0;
      this.esEditable = false;
    }
  }

  getListaPac() {
    this._fs.getListaPacByTechoId(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.listaPac = result.data;
        }
        else { this.listaPac = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getSeleccionarObjeto(e: any) {
    if (e.value != undefined && e.value != null) {
      this.modelFus.solicitud_pac_id = e.value;
      if (this.uId == 12)
        this.esEditable = false;
      else
        this.esEditable = true;
      var obj = this.listaPac.filter(o => o.id == e.value).map(o => o.objeto_contratacion).toString();
      this.modelFus.objeto = obj;
      this.montoPAC = parseFloat(this.listaPac.filter(o => o.id == e.value).map(o => o.total).toString());
    }

  }

}
